<template>
  <div class="signup">
    <h2>Crear Cuenta</h2>

    <vuestic-alert v-if="error" type="danger" :withCloseBtn="true">
      {{error}}
    </vuestic-alert>

    <form @submit.prevent="crearUsuario" name="signup">
      <div class="form-group">
        <div class="input-group">
          <input autocomplete="off" type="text" id="nombreUsuario" v-model="modelNombre" required="required"/>
          <label class="control-label" for="nombreUsuario">Nombre</label>
          <i class="bar"></i>
        </div>
        <div class="input-group">
          <input autocomplete="off" type="text" id="email" v-model="modelEmail" required="required"/>
          <label class="control-label" for="email">Correo Electronico</label>
          <i class="bar"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input autocomplete="off" required="required" v-model="modelDireccion" id="direccion" type="text">
          <label class="control-label" for="direccion">Dirección</label>
          <i class="bar"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input autocomplete="off" type="password" id="password" v-model="modelContrasena"
                 required="required"/>
          <label class="control-label" for="password">Contraseña</label>
          <i class="bar"></i>
        </div>
      </div>
      <div
        class="d-flex align--center justify--space-between down-container">
        <a href="#/usuarios/listar-usuarios">Volver</a>
        <button :disabled="disabledCrear" id="crear" class="btn btn-info btn-micro" type="submit">
          Crear
        </button>
      </div>
      <atom-spinner v-if="loading" class="spinner"></atom-spinner>
    </form>
  </div>
</template>

<script>
  import {uuid} from 'vue-uuid'
  import AtomSpinner from 'epic-spinners/src/components/lib/AtomSpinner'

  export default {
    name: 'signup',
    components: {AtomSpinner},
    data() {
      return {
        modelEmail: '',
        modelContrasena: '',
        modelNombre: '',
        disabledCrear: false,
        modelDireccion: '',
        uuid: uuid.v4(),
        error: '',
        estado: 'activo',
        loading: false
      }
    },
    methods: {
      crearUsuario() {
        this.error = '';
        let data = {
          id: this.uuid,
          nombre: this.modelNombre,
          direccion: this.modelDireccion,
          email: this.modelEmail,
          password: this.modelContrasena,
          estado: this.estado,
          roles: [],
          picking: false,
          encargado: {
            is_encargado: false,
            sucursal_id: "",
            nivel: 0,
            token: ""
          },
          refresh_token: ""
        };
        this.loading = true;
        this.$store.dispatch('register', data)
          .then(() => {
            this.error = '';
            this.loading = false
            this.disabledCrear = false;
            this.$swal('Correcto!', 'Usuario creado correctmente...', 'success')
            this.$router.push('/usuarios/listar-usuarios')
          })
          .catch(err => {
            console.log(err)
            this.error = err.response.data
            this.loading = false;
          })
      },
    }
  }
</script>

<style lang="scss">
  .signup {
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 2rem;
      padding-left: 2rem;
    }

    h2 {
      text-align: center;
    }

    width: 21.375rem;

    .down-container {
      margin-top: 2.6875rem;
    }

    button {
      margin-left: 86px;
    }

    .spinner {
      position: absolute;
      right: 0;
      left: 600px;
      bottom: 23%;
    }

    .input-group {
      margin-left: 10px;
    }
  }
</style>
